import { useField } from 'formik';
import React from 'react';

import { BaseCheckbox } from './BaseCheckbox';
import { CheckboxProps } from './interfaces';

export const Checkbox: React.FC<CheckboxProps> = ({
  label = '',
  errorLabelProps,
  name,
  ...rest
}) => {
  const [field, meta, helpers] = useField<boolean>({ name, type: 'checkbox' });
  const isError = meta.touched && !field.checked && meta.error;

  const onChecked = (e: React.SyntheticEvent<HTMLLabelElement>) => {
    e.persist();
    e.preventDefault();
    helpers.setValue(!field.value);
    helpers.setTouched(true, false);
  };
  return (
    <BaseCheckbox
      label={label}
      {...field}
      {...rest}
      error={isError ? meta.error : undefined}
      labelProps={{ onClick: onChecked }}
      errorLabelProps={errorLabelProps}
    />
  );
};

export default Checkbox;
